import React from 'react'
import './Offer_Banner.css'

const Offer_Banner = ({imgSrc}) => {
  return (
    <section className='Offer_Banner'>
        <div className='banner_holder'>
            <img src={imgSrc} className='banner_img'/>
        </div>
    </section>
  )
}

export default Offer_Banner
